/*
 * Copyright (C) Serfim TIC
 * All rights reserved
 */
class GmaoLineChartController {
    /** @ngInject */
    constructor($log, configuration) {
        this.$log = $log;
        this.configuration = configuration;
        this.$log.debug('Controller \'GmaoLineChartController\' loaded');
    }

    $onInit() {
        this.chartOptions = {
            chart: {
                type: 'lineChart',
                height: 450,
                margin : {
                    top: 20,
                    right: 20,
                    bottom: 60,
                    left: 65
                },

                x: record => record ? record.x : record,
                y: record => record ? record.y : record,

                useInteractiveGuideline: true
            }
        };
    }
}

export { GmaoLineChartController };



// WEBPACK FOOTER //
// ./src/main/front/scripts/module/statistics/component/GmaoLineChart.js